import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

interface FreeSearchPopupProps {
  heading: string
  title: JSX.Element
  createAccountButton?: boolean
  premiumSignupButton?: boolean
  premiumButtonLabel?: string
  foundSolution?: boolean
}

const FreeSearchPopup: React.FC<FreeSearchPopupProps> = ({
  heading,
  title,
  createAccountButton = true,
  premiumSignupButton = true,
  premiumButtonLabel = 'Sign Up for Premium',
  foundSolution = true,
}) => {
  const [dynamicClass, setDynamicClass] = useState('')
  const router = useRouter()
  const handleCreateAccount = () => {
    router.push('/signup/')
  }
  const handlePremiumSignup = () => {
    window.open('https://hub.legaltechnologyhub.com/more-info', '_blank')
  }
  useEffect(() => {
    if (router.pathname == '/companies/[slug]' && foundSolution) {
      setDynamicClass('popup-search-rectangle-companypage-height')
    } else if (router.pathname == '/companies/[slug]' && !foundSolution) {
      setDynamicClass('popup-search-rectangle-companypage-height-nosolution')
    } else if (router.pathname == '/topics/[slug]' || router.pathname == '/topics/[...slug]') {
      setDynamicClass('popup-search-rectangle-custom-height')
    } else if (router.pathname == '/collections/[slug]') {
      setDynamicClass('popup-search-rectangle-collectionpage-height')
    } else if (router.pathname == '/my-followings') {
      setDynamicClass('popup-search-rectangle-followpage-height')
    }
  }, [router.pathname, foundSolution])

  // useEffect(() => {
  //   document.body.classList.add('overflow')

  //   return () => {
  //     document.body.classList.remove('overflow')
  //   }
  // }, [])

  return (
    <div className={`popup-search-rectangle ${dynamicClass}`}>
      <div className="pop-container-outer">
        <div className={`pop-container`}>
          <h2 className="popup-search-heading mb-[4px]">{heading}</h2>
          <div className="popup-search-body">
            <p className="popup-search-title">{title}</p>
            <div
              className={`popup-search-button flex justify-center items-center gap-4 ${!createAccountButton ? 'text-center' : ''}`}
            >
              {createAccountButton && (
                <button
                  className="text-white py-2 px-12 mr-4 font-secondary text-[14px] font-bold text-center h-[50px] !important bg-navy rounded-[25px] w-[247px]"
                  onClick={handleCreateAccount}
                >
                  Create an Account
                </button>
              )}
              {premiumSignupButton && (
                <button
                  className="text-white py-2 px-12 font-secondary text-[14px] font-bold text-center h-[50px] !important bg-navy rounded-[25px] w-[247px]"
                  onClick={handlePremiumSignup}
                >
                  {premiumButtonLabel}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FreeSearchPopup
